import { render, staticRenderFns } from "./xeroConfigDialog.vue?vue&type=template&id=a4657ab0&"
import script from "./xeroConfigDialog.vue?vue&type=script&lang=js&"
export * from "./xeroConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports